import React from "react";
import InputComponent from "../../UI/InputComponent/InputComponent";
import Row from "../WrapperComponents/Row";
import Col from "../WrapperComponents/Col";
import ColDynamic from "../WrapperComponents/ColDynamic";
import ButtonComponent from "../../UI/ButtonComponent/ButtonComponent";

const BasicReviserData = (props) => {
  const { group } = props;

  const basicReviserData = props.parentState.newFormData[group].find(
    (element) => element.id === props.id
  );

  const secId = props.secId || "";

  const revDataArrLength = props.parentState.newFormData[group].length > 1;


  const newLocal = "Registarski broj";
  return (
    <div className="form-group">
      <Row>
        <Col>
          <InputComponent
            required={props.required}
            style={
              props.required &&
              props.parentState.error &&
              basicReviserData.oib.length < 1 &&
              "red"
            }
            onChange={props.mappedUserInputHandler}
            objData={{ id: props.id, group: group }}
            value={basicReviserData.oib}
            id={`$basic-rev-data-oib${props.id}${secId}`}
            name="oib"
            controlLabel={"OIB/Identifikator"}
          />
        </Col>
        <Col>
          <InputComponent
            required={props.required}
            disabled={props.disabled}
            style={
              props.required &&
              props.parentState.error &&
              basicReviserData.prezime.length < 1 &&
              "red"
            }
            onChange={props.mappedUserInputHandler}
            objData={{ id: props.id, group: group }}
            value={basicReviserData.prezime}
            id={`basic-rev-data-prezime${props.id}${secId}`}
            name="prezime"
            controlLabel={"Prezime"}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <InputComponent
            disabled={props.disabled}
            required={props.required}
            style={
              props.required &&
              props.parentState.error &&
              basicReviserData.ime.length < 1 &&
              "red"
            }
            onChange={props.mappedUserInputHandler}
            objData={{ id: props.id, group: group }}
            value={basicReviserData.ime}
            id={`$basic-rev-data-ime${props.id}${secId}`}
            name="ime"
            controlLabel="Ime"
          />
        </Col>
        <Col>
          <InputComponent
            disabled={props.disabled}
            required={props.required}
            style={
              props.required &&
              props.parentState.error &&
              basicReviserData.regBroj.length < 1 &&
              "red"
            }
            onChange={props.mappedUserInputHandler}
            objData={{ id: props.id, group: group }}
            value={basicReviserData.regBroj}
            id={`$basic-rev-data-reg-br${props.id}${secId}`}
            name="regBroj"
            controlLabel={newLocal}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <ButtonComponent onClick={props.handleFetch} id={props.id}>
            Dohvati podatke
          </ButtonComponent>
        </Col>
        <Col></Col>
      </Row>
      <br></br>
      {!props.hideMultiple && (
        <Row>
          <ColDynamic className="col-lg-4">
          {props.parentState.newFormData[group].length -1 === props.idZaBtn ?
            <ButtonComponent
              id={`$basic-rev-data-multiply-btn${props.id}${secId}`}
              onClick={(e) => props.multiplyComponent(e, { formGroup: group })}
            >
              Dodaj novi
            </ButtonComponent>
            : null
          }
          </ColDynamic>
          <ColDynamic className="col-lg-4">
            {revDataArrLength && (
              <ButtonComponent
                variant="danger"
                id={`$basic-rev-data-remove-btn${props.id}`}
                onClick={(e) =>
                  props.removeComponentHandler(e, {
                    formGroup: group,
                  })
                }
              >
                Ukloni
              </ButtonComponent>
            )}
          </ColDynamic>
        </Row>
      )}
    </div>
  );
};

export default BasicReviserData;
